import { ExamCenterDetailsInfoBanner } from '@exam-center/exam-center-management';
import {
  Box,
  Divider,
  Flex,
  FormHelperText,
  mergeSx,
  PaperSection,
  type PaperSectionProps,
  ReadonlyField,
  Text,
} from '@shared/components';

export interface ExamCenterDetailsReadonlyFieldsProps extends Omit<PaperSectionProps, 'title'> {
  values: {
    code: string;
    nameTH: string;
    nameEN: string;
    addressTH: string;
    phoneTH: string;
    addressEN: string;
    phoneEN: string;
    website: string;
    email: string;
    examResultRecipientEmail: string;
  };
}

export default function ExamCenterDetailsReadonlyFields(
  props: Readonly<ExamCenterDetailsReadonlyFieldsProps>,
) {
  const { values, sx, ...restProps } = props;
  const {
    code,
    nameTH,
    nameEN,
    addressTH,
    phoneTH,
    addressEN,
    phoneEN,
    website,
    email,
    examResultRecipientEmail,
  } = values;

  return (
    <PaperSection title='ข้อมูลศูนย์ทดสอบ' sx={mergeSx({ height: '100%' }, sx)} {...restProps}>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          flex: 1,
          p: theme.spacing(6),
          gap: theme.spacing(6),
        })}
      >
        <ExamCenterDetailsInfoBanner />
        <Flex sx={{ width: '100%' }}>
          <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
            Exam Center Code
          </Text>
          <Box sx={{ width: '240px' }}>
            <ReadonlyField content={code} />
          </Box>
        </Flex>

        <Flex sx={{ width: '100%' }}>
          <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
            ข้อมูลภาษาไทย
          </Text>
          <Flex sx={(theme) => ({ flexDirection: 'column', flex: 1, gap: theme.spacing(4) })}>
            <ReadonlyField label='ชื่อศูนย์ทดสอบ (ภาษาไทย)' content={nameTH} />
            <ReadonlyField label='ที่อยู่ (ภาษาไทย)' content={addressTH} />
            <ReadonlyField label='โทรศัพท์ (ภาษาไทย)' content={phoneTH} />
          </Flex>
        </Flex>

        <Divider />

        <Flex sx={{ width: '100%' }}>
          <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
            ข้อมูลภาษาอังกฤษ
          </Text>
          <Flex sx={(theme) => ({ flexDirection: 'column', flex: 1, gap: theme.spacing(4) })}>
            <ReadonlyField label='ชื่อศูนย์ทดสอบ (ภาษาอังกฤษ)' content={nameEN} />
            <ReadonlyField label='ที่อยู่ (ภาษาอังกฤษ)' content={addressEN} />
            <ReadonlyField label='โทรศัพท์ (ภาษาอังกฤษ)' content={phoneEN} />
          </Flex>
        </Flex>

        <Divider />

        <Flex sx={{ width: '100%' }}>
          <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
            เว็บไซต์และอีเมล
          </Text>
          <Flex sx={(theme) => ({ flexDirection: 'column', flex: 1, gap: theme.spacing(4) })}>
            <ReadonlyField label='เว็บไซต์' content={website} />
            <ReadonlyField label='อีเมล' content={email} />
            <Box>
              <ReadonlyField label='อีเมลรับผลการสอบ (BCC)' content={examResultRecipientEmail} />
              <FormHelperText sx={{ mt: 0.5 }}>
                อีเมลนี้จะได้รับสำเนาอีเมลผลการสอบของผู้เข้าสอบทุกคน
                เพื่อให้ศูนย์ทดสอบส่งต่อให้ผู้เข้าสอบเองได้ กรณีผู้เข้าสอบไม่ได้รับอีเมล
              </FormHelperText>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </PaperSection>
  );
}
